// PrivacyToggle.jsx
import React from 'react';
import '../../styles/components/admin/PrivacyToggle.css';

const PrivacyToggle = ({ isPublic, onToggle, label }) => {
  return (
    <div className="privacy-toggle-container">
      <span className="privacy-toggle-label">{label || "Visibility"}</span>
      <div className="privacy-toggle">
        <button 
          className={`privacy-toggle-btn ${isPublic ? 'active' : ''}`}
          onClick={() => onToggle(true)}
        >
          Public
        </button>
        <button 
          className={`privacy-toggle-btn ${!isPublic ? 'active' : ''}`}
          onClick={() => onToggle(false)}
        >
          Private
        </button>
      </div>
      <div className="privacy-status-indicator">
        <span className={`privacy-status ${isPublic ? 'public' : 'private'}`}>
          {isPublic ? 'Public' : 'Private'}
        </span>
      </div>
    </div>
  );
};

export default PrivacyToggle;